// extracted by mini-css-extract-plugin
export default {"groupField":"styles_groupField__8wfBk","grabPoint":"styles_grabPoint__H9xOP"};